import api from './axiosService';

export const userLogApi = {
    getAll(params = {}) {
        return api.get('/user-logs', { params });
    },

    getStats(params = {}) {
        return api.get('/user-logs/stats', { params });
    },

    getByUser(username, params = {}) {
        return api.get(`/user-logs/user/${username}`, { params });
    },

    getById(userlogId) {
        return api.get(`/user-logs/${userlogId}`);
    },
};